export class InvalidAwsRegionError extends Error {
  constructor() {
    super('AWS region not specified or not a string.');
  }
}
